module.exports = __webpack_public_path__ + "static/media/statistical.a3a271e8.svg";